(function () {
  function initKit(root) {
    if (!root || root.getAttribute('data-phk-ready')) return;
    root.setAttribute('data-phk-ready', 'true');

    var cartAddUrl = root.getAttribute('data-cart-add');
    var cartUrl = root.getAttribute('data-cart-url');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));

    function selectTab(i, focus) {
      tabs.forEach(function (t, j) {
        t.setAttribute('aria-selected', j === i ? 'true' : 'false');
        t.tabIndex = j === i ? 0 : -1;
      });
      panels.forEach(function (p, j) { p.hidden = j !== i; });
      if (focus && tabs[i]) tabs[i].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { selectTab(i, false); });
      tab.addEventListener('keydown', function (e) {
        var next = -1;
        if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next > -1) { e.preventDefault(); selectTab(next, true); }
      });
    });

    panels.forEach(function (panel) {
      var stage = panel.querySelector('[data-stage]');
      var main = panel.querySelector('[data-main]');
      var thumbs = Array.prototype.slice.call(panel.querySelectorAll('[data-thumb]'));
      var count = panel.querySelector('[data-count]');
      var idx = 0;

      function show(n) {
        if (!thumbs.length || !main) return;
        idx = (n + thumbs.length) % thumbs.length;
        var t = thumbs[idx];
        main.srcset = t.getAttribute('data-srcset');
        main.src = t.getAttribute('data-src');
        main.alt = t.getAttribute('data-alt') || '';
        thumbs.forEach(function (x, j) {
          if (j === idx) x.setAttribute('aria-current', 'true');
          else x.removeAttribute('aria-current');
        });
        if (count) count.textContent = (idx + 1) + ' / ' + thumbs.length;
        var strip = t.parentNode;
        if (strip && strip.scrollTo) {
          strip.scrollTo({ left: t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
        }
      }

      if (thumbs.length && stage) {
        if (count) count.textContent = '1 / ' + thumbs.length;
        thumbs.forEach(function (t, j) { t.addEventListener('click', function () { show(j); }); });
        var prev = panel.querySelector('[data-prev]');
        var next = panel.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', function () { show(idx - 1); });
        if (next) next.addEventListener('click', function () { show(idx + 1); });

        var startX = null;
        stage.addEventListener('touchstart', function (e) { startX = e.changedTouches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (startX === null) return;
          var dx = e.changedTouches[0].clientX - startX;
          startX = null;
          if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }

      var select = panel.querySelector('[data-variant]');
      var priceEl = panel.querySelector('[data-price]');
      var compareEl = panel.querySelector('[data-compare]');
      if (select && priceEl) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          priceEl.textContent = opt.getAttribute('data-price');
          if (compareEl) compareEl.style.display = 'none';
        });
      }

      var form = panel.querySelector('[data-form]');
      var btn = panel.querySelector('[data-add]');
      var status = panel.querySelector('[data-status]');
      if (!form || !btn) return;
      var label = btn.getAttribute('data-label');
      var timer = null;

      function reset() {
        btn.disabled = false;
        btn.textContent = label;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        btn.disabled = true;
        btn.textContent = 'Adding...';
        status.textContent = '';
        clearTimeout(timer);

        fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw new Error(data.description || data.message || 'This item could not be added.');
              return data;
            });
          })
          .then(function () {
            btn.textContent = 'Added to cart';
            status.innerHTML = 'Added to your cart. <a href="' + cartUrl + '">View cart</a>';
            document.querySelectorAll('.cart-link__bubble').forEach(function (el) {
              el.classList.add('cart-link__bubble--visible');
            });
            timer = setTimeout(reset, 2500);
          })
          .catch(function (err) {
            status.textContent = err.message;
            reset();
          });
      });
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-phk]'), initKit);
  }

  initAll();
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);
})();